import { isAccountFeatureEnabled } from "owa-feature-flags";
import type { MailboxInfo } from "owa-client-types";

/**
 * Account-level half of the "Recent" section gate: whether this account is served by 3S *and* is
 * flighted into the supplementary recent-results request.
 *
 * Lives here rather than beside the request builder because two callers in different bundles need
 * it - the served search path and the boot-time warm-up - and a duplicated pair of flight checks
 * would let the warm-up drift out of step with the feature it exists to warm.
 *
 * Deliberately excludes the per-request conditions (page number, search ordinal, provider,
 * connectivity): those are meaningless at boot, and folding them in would force the warm-up to
 * invent values for them.
 */
export default function isRecentSectionAccountEligible(mailboxInfo: MailboxInfo): boolean {
    if (!isAccountFeatureEnabled("sea-gwc-outlook-infra-recent-section", mailboxInfo)) {
        return false;
    }
    
    // When the account already serves search from the recent-results backend, the main list is
    // that backend's own ranking - a "Recent" strip drawn from it would be showing rows that are
    // already immediately below it, and its index is warmed by the served init anyway.
    if (isAccountFeatureEnabled("sea-gwc-outlook-infra-latency-testing", mailboxInfo)) {
        return false;
    }
    
    return true;
}
